/*
 * @Author: xuxinxiang
 * @Date: 2023-10-09 17:12:03
 * @LastEditors: xuxinxiang
 * @LastEditTime: 2024-01-11 11:02:13
 * @Description: 
 */
import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/robot' //重定向
  },
  {
    path: '/robot',
    name: 'Robot',
    component: () => import ('../views/robot/Index.vue'),
  },
  {
    path: '/failureLink',
    name: 'failureLink',
    component: () => import ('../views/failureLink/Index.vue'),
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
